import React from "react";

import { useTranslation } from "react-i18next";

import { AppConfig } from "../../../../../constants";
import { ButtonImage, FooterContainer, Logo, PoweredBy } from "./styles";

interface FooterProps {
  center?: boolean;
}

const CustomerPortalFooter = ({ center = false }: FooterProps) => {
  const { t: translate } = useTranslation();

  const openShipeeziWeb = () => {
    window.open("https://www.shipeezi.com", "blank");
  };

  return (
    <FooterContainer center={center}>
      <ButtonImage onClick={() => openShipeeziWeb()}>
        <PoweredBy>{translate("poweredBy")}</PoweredBy>
        <Logo src={AppConfig.appLogo} />
      </ButtonImage>
    </FooterContainer>
  );
};

export { CustomerPortalFooter };
